import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentsContainerComponent } from './comments-container/comments-container.component';
import { ComponentFormFieldComponent } from './component-form-field/component-form-field.component';
import { QuillModule } from 'ngx-quill';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'ZalamoLibrary/src/lib/ui/button/button/button.module';
import { CommentsListComponent } from './comments-list/comments-list.component';
import { OrganizationMemberModule } from 'ZalamoLibrary/src/lib/ui/organization-member/organization-member.module';
import { LuxonModule } from 'luxon-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslationsModule } from 'ZalamoLibrary/src/lib/ui/nls/translations/translations.module';
import { NameAvatarGeneratorPipe } from './comments-list/name-avatar-generator.pipe';
import { MarkCommentAsReadDirective } from './mark-comment-as-read.directive';

@NgModule({
  declarations: [
    CommentsContainerComponent,
    ComponentFormFieldComponent,
    CommentsListComponent,
    NameAvatarGeneratorPipe,
    MarkCommentAsReadDirective,
  ],
  exports: [
    CommentsContainerComponent,
    NameAvatarGeneratorPipe,
    ComponentFormFieldComponent,
  ],
  imports: [
    CommonModule,
    QuillModule,
    ReactiveFormsModule,
    ButtonModule,
    OrganizationMemberModule,
    LuxonModule,
    MatTooltipModule,
    TranslationsModule,
  ],
})
export class CommentsModule {}
